import { IonButton, IonIcon, IonInput, IonItem } from '@ionic/react';
import { withTranslation } from '../../lib/translate.js';
import { sendVoucherCode, setCommonProp } from '../../store/actions.js';
import { connect } from 'react-redux';
import { Component } from 'react';
import './index.css';
import Modal from '../modal/index.js';
import { NormalText, Spacer, StrongText, Title } from '../common/index.js';
import successIcon from '../../assets/images/success-icon.png';
import { checkmarkCircle } from 'ionicons/icons';


class VoucherCodeInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      voucherCode: '',
      voucherCodeAlertVisible: false
    }
  }
  handlerOfVoucherCode = (e) => {
    const val = e.target.value.toUpperCase();
    this.setState({ voucherCode: val });
  };
  sendCode = () => {
    const { dispatch } = this.props;
    const { voucherCode } = this.state;
    const data = { code: voucherCode.toUpperCase() };
    this.setState({ voucherCode: '' });
    dispatch(sendVoucherCode(data, false));
  };

  render() {
    const { __, className, children, useCustomButton, buttonText, showButton = false } = this.props;
    const { voucherCode } = this.state;
    return (
      <>
        {showButton &&
          <>
            {!children ? <>
              <IonButton className="redeem-voucher-btn"
                onClick={() => {
                  this.setState({ voucherCodeAlertVisible: true });
                }}
                expand='block'
                color='secondary'

              >
                {__(buttonText) || __('Redeem voucher code')}
              </IonButton>
            </> : <div
              onClick={() => {
                this.setState({ voucherCodeAlertVisible: true });
              }}
            >{children}</div>}
            <Modal onDidDismiss={() => this.setState({ voucherCodeAlertVisible: false })} isOpen={this.state.voucherCodeAlertVisible} className="modal-type-alert">
              <StrongText className='block'>{__('Apply voucher code')}</StrongText>
              <Spacer size={5} />
              <div className="input-field-container">
                <IonItem className="input-field-wrapper" lines="none">
                  <IonInput
                    placeholder={__('Voucher code')}
                    onIonInput={(e) => this.handlerOfVoucherCode(e)}
                    value={voucherCode}
                  ></IonInput>
                </IonItem>
              </div>
              <div className='alert-button-group'>
                <IonButton
                  color="secondary"
                  expand="block"
                  onClick={() => this.setState({ voucherCodeAlertVisible: false })}
                  className="submit-button"
                >
                  {__('Cancel')}
                </IonButton>
                <IonButton
                  disabled={voucherCode === ''}
                  color="primary"
                  expand="block"
                  onClick={this.sendCode}
                  className="submit-button"
                >
                  {__('Save')}
                </IonButton>
              </div>

            </Modal>


            <Modal onDidDismiss={() => this.props.dispatch(setCommonProp('voucherAddedModalOpen', false))} isOpen={this.props.voucherAddedModalOpen} className="modal-type-alert">
              <StrongText className='block'>{__('Success!')}</StrongText>
              <Spacer size={5} />
              <div style={{display:'grid',justifyItems:'center',textAlign:'center'}}>
                <IonIcon style={{height:'48px',width:'48px'}} color='success' icon={checkmarkCircle}></IonIcon>
                <Title  className='block'>{__("Voucher added")}</Title>
                <NormalText className='block'>{__('This voucher has been added to your account and is ready to be used.')}</NormalText>
              </div>
              <Spacer size={5} />

              <div className='alert-button-group'>
                <IonButton
                  color="primary"
                  expand="block"
                  onClick={() => this.props.dispatch(setCommonProp('voucherAddedModalOpen', false))}
                  className="submit-button"
                >
                  {__('Nice!')}
                </IonButton>

              </div>

            </Modal>

          </>
        }
      </>
    );
  }
}

export default connect()(withTranslation(VoucherCodeInput));
